import React from "react"
import { Row, Col, Badge } from "reactstrap"
import PropTypes from "prop-types"
import { FILES_URL } from "helpers/url_helper" // Assuming you have this for user avatars, or use placeholder

const LocationEmployees = ({ employees }) => {
    if (!employees || employees.length === 0) return null

    return (
        <div className="mb-4">
            {/* Title */}
            <h5 style={{ color: "#FFCA5C", marginBottom: "20px", fontWeight: "bold" }}>Employees</h5>

            {/* Horizontal Scroll Container */}
            <div
                className="d-flex"
                style={{
                    overflowX: "auto",
                    paddingBottom: "10px", // Space for scrollbar
                    gap: "20px",
                    scrollbarWidth: "thin", // For Firefox
                }}
            >
                {employees.map((s, idx) => {
                    // --- Logic from your previous code ---
                    const totalHours = s.user?.shift_entries
                        ? s.user.shift_entries.reduce(
                            (sum, se) => sum + (parseFloat(se.net_hours) || 0),
                            0
                        )
                        : 0

                    const oneShift = s.user?.shift_entries?.[0]
                    let paymentType = "1099"
                    if (oneShift && oneShift.payment_type && oneShift.payment_type !== "1099") {
                        paymentType = "W2"
                    }
                    // -------------------------------------

                    // Get avatar URL or placeholder
                    const avatarUrl = s.user?.picture
                        ? `${FILES_URL}${s.user.picture}`
                        : null

                    return (
                        <div
                            key={idx}
                            style={{
                                minWidth: "220px", // Fixed width for cards
                                backgroundColor: "#3C3C3C", // Dark card background
                                borderRadius: "15px",
                                padding: "20px",
                                textAlign: "center",
                                flexShrink: 0, // Prevents shrinking
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                boxShadow: "0 4px 6px rgba(0,0,0,0.2)"
                            }}
                        >
                            {/* Avatar */}
                            <div
                                style={{
                                    width: "80px",
                                    height: "80px",
                                    borderRadius: "50%",
                                    border: "3px solid #FFCA5C", // Gold border
                                    backgroundColor: "#000",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginBottom: "5px",
                                    overflow: "hidden",
                                    flexShrink: 0,
                                }}
                            >
                                {avatarUrl ? (
                                    <img
                                        src={avatarUrl}
                                        alt="Logo"
                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                    />
                                ) : (
                                    // Fallback icon if no logo
                                    <i className="bx bxs-car" style={{ fontSize: "30px", color: "#fff" }}></i>
                                )}
                            </div>

                            {/* Name */}
                            <h6
                                className="mb-2"
                                style={{
                                    color: "#FFCA5C",
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    width: "100%"
                                }}
                            >
                                {s.user?.full_name || s.user?.employee_alias || "Unknown"}
                            </h6>

                            {/* Status Badge */}
                            <Badge
                                color="dark" // Using dark + custom style to match image "pill" look
                                pill
                                style={{
                                    backgroundColor: "#2A2A2A",
                                    color: s.is_active === 1 ? "#7BB64E" : "#888", // Green text if active
                                    padding: "5px 15px",
                                    fontSize: "11px",
                                    marginBottom: "20px",
                                    border: "1px solid #444"
                                }}
                            >
                                {s.is_active === 1 ? "Active" : "Passive"}
                            </Badge>

                            {/* Stats Row */}
                            <div className="d-flex justify-content-between w-100 mt-auto">
                                {/* Working Hours */}
                                <div className="text-center">
                                    <div style={{ color: "#fff", fontSize: "14px", fontWeight: "600" }}>
                                        {totalHours.toFixed(1)}
                                    </div>
                                    <div style={{ color: "#888", fontSize: "10px" }}>
                                        Working Hours
                                    </div>
                                </div>

                                {/* Payment Type */}
                                <div className="text-center">
                                    <div style={{ color: "#fff", fontSize: "14px", fontWeight: "600" }}>
                                        {paymentType}
                                    </div>
                                    <div style={{ color: "#888", fontSize: "10px" }}>
                                        Payment Type
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

LocationEmployees.propTypes = {
    employees: PropTypes.array
}

export default LocationEmployees